import React from 'react';

import {Avatar, Box, useTheme} from '@mui/material';

const styles = {
    playerCircleContainer: {
        cursor: 'grab',
        position: 'relative',
        '&:hover': {
            transform: 'scale(1.03)',
        },
        '&:active': {
            transform: 'scale(1.07)',
            cursor: 'grabbing',
        }
    },
    playerDisabled: theme => ({
        opacity: theme.palette.lineup.playerDisabled,
        filter: 'grayscale(0.6) blur(0.5px)',
        overflow: 'hidden',
    }),
    avatar: (theme, colors) => ({
        color: `${colors.value2} !important`,
        background: `linear-gradient(145deg, ${colors.value1} 0%, ${colors.value1} 100%) !important`,
        border: `2px solid ${theme.palette.lineup.avatarBorder}`,
        boxShadow: theme.palette.lineup.playerShadow,
        fontWeight: '700',
        fontSize: '18px',
        width: '60px',
        height: '60px',
        transition: 'scale 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
        position: 'relative',
        '&::before': {
            content: '""',
            position: 'absolute',
            top: '-2px',
            left: '-2px',
            right: '-2px',
            bottom: '-2px',
            background: 'linear-gradient(45deg, transparent, rgba(255,255,255,0.3), transparent)',
            borderRadius: '50%',
            opacity: 0,
            transition: 'opacity 0.3s ease',
        },
        '&:hover::before': {
            opacity: 1,
            animation: 'rotate 0.6s linear',
        },
    })
};

const PlayerCircle = ({number, colors, disabled}) => {
    const theme = useTheme();
    return (
        <Box sx={styles.playerCircleContainer}>
            <Avatar sx={{
                ...styles.avatar(theme, colors),
                ...(disabled && styles.playerDisabled(theme))
            }}>
                {number}
            </Avatar>
        </Box>
    );
};

export default PlayerCircle;
